module.exports = __webpack_public_path__ + "static/img/sf3.1a448e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/course/sf3.png
// module id = y5xg
// module chunks = 0